module.exports = __webpack_public_path__ + "static/media/aboutus.72ae8127.jpg";